import React from "react";

import { Route } from "react-router-dom";

import { ENCODING_PROFILES_ROUTE } from "./routes";
import EncodingProfileEdit from "../encodingProfile/encodingProfileEdit/EncodingProfileEdit";
import EncodingProfileList from "../encodingProfile/encodingProfileList/EncodingProfileList";

export interface FASTChannelRoutesParams {
  channelId: string;
}

function EncodingProfileRoutes(): React.JSX.Element {
  return (
    <React.Fragment>
      <Route
        exact
        component={EncodingProfileList}
        path={ENCODING_PROFILES_ROUTE}
      />
      <Route
        component={EncodingProfileEdit}
        path={`${ENCODING_PROFILES_ROUTE}/:id`}
      />
    </React.Fragment>
  );
}

export default EncodingProfileRoutes;
